import Account from "@/helper/AccountHelper.js";
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
import ConfigManager from '@/config/ConfigManager.js';


/**
 * @method apiGetCampaign
 * @method apiRemoveFavourite
 */
export default {

    apiGetHelpCode: function () {
        const token = Account.getToken();

        const url = ConfigManager.getApiUrl() + "/profile/me/help";

        return BzbsApi.connectBzbsPost(url, token, null)
            .pipe(map((res) => {
                // console.log(res.data)
                let helpCode = res.data;
                return helpCode;
            }));
    },
}
